import { IUser } from "./types";
import {
  cleanUserPreferenceLocalStorage,
  getUserPreferenceLocalStorage,
  setAccessTokenLocalStorage,
  getAccessTokenLocalStorage,
  setUserAuthLocalStorage,
  getUserAuthLocalStorage,
  handleUserLogOut,
  setUserPreferenceLocalStorage,
} from "./utils";

export function IsAuthenticated(): boolean {
  let userData = getUserAuthLocalStorage();
  let token = getAccessTokenLocalStorage();
  if (
    variableIsDiferentNullAndUndefined(userData?.token) &&
    variableIsDiferentNullAndUndefined(token) &&
    token !== ""
  ) {
    return true;
  }
  return false;
}

export function variableIsDiferentNullAndUndefined(value: any) {
  return value !== undefined && value !== null;
}

export function handleDisconnectedUserAux({
  data,
  userAuthenticated,
  userIsAuthenticated,
  setUser,
  setUserAuthenticated,
  user,
  userPreference,
}) {
  handleDisconnectedUserPreRequestAux({
    data,
    userAuthenticated,
    setUserAuthenticated,
    user,
    userPreference,
  });
  if (
    Number(data?.Code) === 401 &&
    IsAuthenticated() === true &&
    (userAuthenticated === true || userIsAuthenticated === true)
  ) {
    handleUserLogOut();
    setUser(null);
    setUserAuthenticated(false);
  }
}

export function handleDisconnectedUserPreRequestAux(objParams) {
  if (
    (objParams.data === undefined || objParams.data === null) &&
    variableIsDiferentNullAndUndefined(objParams.user) &&
    variableIsDiferentNullAndUndefined(objParams.user?.token)
  ) {
    setUserAuthLocalStorage(objParams.user);
    setAccessTokenLocalStorage(objParams.user?.token);
    setUserPreferenceLocalStorage(objParams.userPreference, objParams.user);
    if (IsAuthenticated() && !objParams.userAuthenticated) {
      objParams.setUserAuthenticated(true);
    }
  }
}
export function authHeaders(token: string, isForm: boolean) {
  let contentType =
    isForm === true ? "application/x-www-form-urlencoded" : "application/json";
  return {
    Authorization: "Bearer " + token,
    "Content-Type": contentType,
    Accept: "application/json",
  };
}
export function validUserIsConected(user: IUser | null): boolean {
  return (
    user?.token !== null && user?.token !== undefined && user?.token !== ""
  );
}
export function checkUserIsLogged(
  setUser,
  userAuthenticated,
  setUserAuthenticated
) {
  const tempUser = getUserPreferenceLocalStorage();
  const temptoken = getAccessTokenLocalStorage();
  handleTokenCheckUserIsLogged(tempUser, temptoken);
  const userStorage = getUserAuthLocalStorage();
  if (validUserIsConected(userStorage)) {
    handleCheckUserIsLogged(
      userStorage,
      setUser,
      userAuthenticated,
      setUserAuthenticated
    );
  } else {
    handleCheckUserIsNotLogged(
      userAuthenticated,
      setUser,
      setUserAuthenticated
    );
  }
}
export function handleTokenCheckUserIsLogged(tempUser, temptoken) {
  if (tempUser && temptoken === null) {
    if (tempUser.rememberLogin === false) {
      cleanUserPreferenceLocalStorage();
    } else {
      setAccessTokenLocalStorage(tempUser.token);
    }
  }
}
export function handleCheckUserIsNotLogged(
  userAuthenticated,
  setUser,
  setUserAuthenticated
) {
  if (!IsAuthenticated() && userAuthenticated === true) {
    setUser(null);
    setUserAuthenticated(false);
  }
}
export function handleCheckUserIsLogged(
  userStorage,
  setUser,
  userAuthenticated,
  setUserAuthenticated
) {
  setUser(userStorage);
  if (IsAuthenticated() && !userAuthenticated) {
    setUserAuthenticated(true);
  }
} 